const concat = "<br />"

const aboutoriginator = {
"About the Originator – Navi Finserv": [
    {
      question: "What is the business of Navi Finserv Limited (Navi)?",
      answer:"Navi Finserv is a non-deposit taking, systemically important NBFC registered with RBI. The company offers lending products like Personal loans and Home loans under the ‘Navi’ brand. Navi lends through a digital Navi-app only process with its target segment being the young, digitally connected middle-class population in India. The company is a wholly owned subsidiary of Navi Technologies Limited and led by Mr. Sachin Bansal (CEO &amp; Executive Chairman)."
    },
    {
      question: "What are the strengths of Navi?",
      answer:"<b>a. Strong Promoter:</b> Sachin Bansal (ex-founder Flipkart) holds about 98% in Navi Technologies Limited (NTL), which holds 100% stake in Navi Finserv. NTL has a strong capacity to extend capital support to Navi Finserv." + concat + concat +
      "<b>b. Healthy Capitalization:</b> The Capital Adequacy Ratio (CRAR) is 28.6% which is significantly higher than the RBI Minimum limit of 15%" + concat + concat +
      "<b>c. Excellent Asset Quality:</b> Navi has a low GNPA of 1.53% and NNPA of 0.08%." + concat + concat +
      "<b>d. Granular &amp; Diversified Portfolio:</b> The average ticket size of Personal loans is Rs. 60K and for Housing loans is Rs. 57L." + concat + concat +
      "<b>e. Strong Profitability:</b> The company posted a strong profit of Rs. 162 Cr. for FY23" + concat + concat +
      "<b>f. Marquee Lenders:</b> Navi has a diversified pool of lenders across PSU Banks, Private Banks and NBFCs. They have more than 50 lenders which include SBI, HDFC Bank, ICICI Bank, Kotak Bank." + concat + concat
    },
    {
      question: "What are the major risks to Navi?",
      answer: "a. Limited vintage in the non-microfinance portfolioa. Limited vintage in the non-microfinance portfolio" + concat + 
       "b. Microfinance portfolio quality remains susceptible to local socio-political issues and other regulatory and macro factors" + concat
    },
    {
      question: "What is the Credit rating of Navi?",
      answer: "Navi has a credit rating of CRISIL A/ Stable Outlook."
    },
    {
      question: "What is the AUM of Navi?",
      answer: "The total managed AUM as on 31 st Mar, 2023 is Rs. 7,858 Crs."
    },
    {
      question: "What is the profitability of Navi?",
      answer: "The Yield of the Personal Loan portfolio is 23.9% and Housing Loan portfolio is 8.3%" + concat +
      "Profit Before Tax (PBT) is Rs. 180 Crs" + concat +
      "Profit After Tax (PAT) is Rs. 162 Crs" + concat +
      "(Data for FY23)" + concat
    },
    {
      question: "How is the asset quality of Navi?",
      answer: "The Asset quality of Navi is strong with GNPA of 1.53% and NNPA of 0.08% as on 31 st Mar, 2023."
    },
    {
      question: "What is the Capital Adequacy ratio?",
      answer: "The Capital Adequacy Ratio (CRAR) as on 31 st Mar, 2023 is 28.6%"
    },
  ],
}

export default aboutoriginator;